// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { MessageProcessorBase } from './MessageProcessorBase';
import { PFixXmlMessage } from '../Messages/PFixXmlMessage';
export class XMLMessageProcessor extends MessageProcessorBase {
    decode(fieldSet) {
        // TODO. Ugly. Refactor.
        // Hack for using "Request id + Promise" feature in ProcessorWorker.
        return [new PFixXmlMessage(fieldSet)];
    }
}
